import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWineGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.05168 2.91562C6.09543 2.4 6.52981 2 7.04856 2H13.0486C13.5673 2 14.0017 2.4 14.0454 2.91562L14.4829 8.17812C14.6704 10.4281 13.1548 12.4031 11.0486 12.8844V16H12.5486C13.1017 16 13.5486 16.4469 13.5486 17C13.5486 17.5531 13.1017 18 12.5486 18H10.0486H7.54856C6.99543 18 6.54856 17.5531 6.54856 17C6.54856 16.4469 6.99543 16 7.54856 16H9.04856V12.8875C6.94231 12.4062 5.42668 10.4312 5.61418 8.18125L6.05168 2.91875V2.91562ZM7.80168 6H12.2954L12.1298 4H7.96731L7.80168 6Z",
		fill: "#0D2976"
	})
});
export default SvgWineGlass;
